/**
 * @desc 查看周曲线
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.EPWeeklyCurveRequest,
): Promise<defs.StandardReturn<Array<defs.EPWeeklyCurveResponse>>> {
  return defHttp.post({
    url: '/web/EPManage/getEPWeeklyCurve',
    data,
  });
}

export function mock(
  data: defs.EPWeeklyCurveRequest,
): Promise<defs.StandardReturn<Array<defs.EPWeeklyCurveResponse>>> {
  return defHttp.post({
    url: '/mock/web/EPManage/getEPWeeklyCurve',
    data,
  });
}
